import React from "react";
import styles from "./card.module.scss";
import DeleteIcon from "Assets/icon/icon-delete.svg";

export interface InputSwitchProps {
  id: string;
  label: string;
  icon: string;
  subCompanyName: string;
  styling?: string;
  onDelete?: () => void;
}
export const LongCard: React.FC<InputSwitchProps> = ({
  id,
  label,
  icon,
  subCompanyName,
  styling,
  onDelete,
}) => {
  return (
    <div className={`${styles["toggle"]} ${styling}`}>
      <div className={styles["long-card--container"]}>
        <div className={styles["label"]}>
          <div>{icon && <img src={icon} alt="logo" />}</div>
          <div>
            <div className={styles["sub-label "]}>{subCompanyName}</div>
            <div className={styles["label"]}>{label}</div>
          </div>
        </div>
        <img
          src={DeleteIcon}
          alt="delete-icon"
          className="delete-icon"
          onClick={onDelete}
        />
      </div>
    </div>
  );
};
